var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRepair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.088 4.11L9.409 5.79h-.003l-.34-.09-.005-.002-1.379-.37-.344-.092h-.002v-.003l-.093-.345-.368-1.37-.092-.346v-.003L8.47 1.48a.31.31 0 00-.015-.45.311.311 0 00-.203-.074h-.045-.001a3.39 3.39 0 00-2.394.996A3.397 3.397 0 004.89 5.06v.003L1.14 8.815c-.328.328-.521.671-.582 1.02-.091.523.118 1.057.627 1.567.367.366.73.571 1.11.627.15.022.3.02.448-.007.353-.062.7-.261 1.033-.595l3.741-3.742a3.397 3.397 0 003.107-.923c.661-.661.996-1.577.996-2.282v-.113-.043a.314.314 0 00-.11-.24.315.315 0 00-.421.027z",
    fill: "#2E2E2E"
  })));
}

export default SvgRepair;